import React, { useCallback } from "react";
import { Text, Icons } from "@pushpress/shared-components";
import { Badge } from "@pushpress/committed-club-typescript-sdk";
import { useHistory } from "react-router-dom";
import { useAnalytics } from "../../components/providers/AnalyticsProvider";
import { CommittedClubEvent } from "./CommittedClubEvents";

interface BadgeListItemProps {
  badge: Badge;
}

const BadgeListItem = (props: BadgeListItemProps) => {
  const { badge } = props;

  const history = useHistory();

  const { trackEvent } = useAnalytics();

  const viewMonthProgress = useCallback(() => {
    trackEvent(CommittedClubEvent.MonthSelected, {
      page: "committed_club_dashboard",
      month_state: badge.isActive ? "in_progress" : "complete",
      live_now: true,
      app: "committed_club",
    });

    history.push(`/committed-club/progress/${badge.uuid}`);
  }, [badge, history, trackEvent]);

  return (
    <button
      onClick={viewMonthProgress}
      className="tw-bg-white tw-w-full tw-text-left tw-flex tw-items-center tw-justify-between tw-border-gray-300 tw-border tw-py-6 tw-px-4 tw-rounded-lg tw-transition-colors tw-duration-200 tw-ease-in-out tw-group hover:tw-bg-gray-100  hover:tw-bg-gray-100/50 hover:tw-cursor-pointer"
    >
      <div className="tw-flex tw-items-center tw-justify-between tw-space-x-4">
        <div className="tw-flex tw-items-center  tw-space-x-4">
          <Text weight="400" variant="heading-5" color="black">
            {badge.title}
          </Text>
          {badge.isActive && (
            <Text weight="400" variant="body-sm" color="wolf-500">
              IN-PROGRESS
            </Text>
          )}
        </div>
      </div>

      <div className="tw-flex tw-items-center tw-justify-between">
        <Text weight="400" variant="heading-5" color="black">
          {badge.badgesCount}
        </Text>
        <div className="tw-w-1" />
        {<Icons.User />}
        <div className="tw-w-2" />
        {<Icons.CaretRight />}
      </div>
    </button>
  );
};

export default BadgeListItem;
